export const ErrorMessageConfig = {
	NETWORK_ERROR: 'Network error please contact admin.',
};
